<template>
	<vs-prompt
		:active.sync="activeProp"
		:buttons-hidden="true"
		:title="$t('enterPromocode')"
		:cancel-text="$t('refuse')"
		button-accept="false"
		button-cancel="filled"
		color="warning"
		class="confirm-popup"
	>
		<div class="con-example-prompt">
			<div class="vx-col">
				<p class="mb-2 text-sm">{{ $t("promocodeHint") }}</p>
				<vs-input
					v-model="promocodeData"
					:label="$t('promocode')"
					class="w-full"
					@input="showError = false"
				/>
				<p v-if="showError" class="text-danger text-sm mt-1">
					{{ $t("promocodeRequired") }}
				</p>
			</div>

			<div class="flex justify-end mt-3">
				<vs-button @click="confirm" color="warning">
					{{ $t("confirm") }}
				</vs-button>
			</div>
		</div>
	</vs-prompt>
</template>

<script>
export default {
	name: "ConfirmPromocodePopup",
	props: {
		active: { default: false, type: Boolean }
	},

	data() {
		return {
			promocodeData: "",
			showError: false
		};
	},

	watch: {
		active(newVal) {
			if (newVal) {
				this.promocodeData = "";
				this.showError = false;
			}
		}
	},

	computed: {
		activeProp: {
			get() {
				return this.active;
			},
			set(value) {
				this.$emit("update:active", value);
				return this.active;
			}
		}
	},

	methods: {
		confirm() {
			const value = (this.promocodeData || "").trim();
			if (!value) {
				this.showError = true;
				return;
			}

			this.showError = false;
			this.$emit("confirm", value);
			this.activeProp = false;
		}
	}
};
</script>

<style lang="scss">
.confirm-popup {
	.vs-dialog {
		max-width: 320px;
	}
}
</style>
